export const DISPLAYING_FOR = {
  DOUBT: "doubt",
  ANSWER: "answer",
  COMMENT: "comment",
  HOME: "home"
};